<div>

  <tabset #staticTabs>
    <tab heading="General">
      <app-generalForm></app-generalForm>

      <!-- <app-specificForm></app-specificForm>  -->
    </tab>
    <tab heading="{{ 'ContactTabs.SpecificProperty' | translate }}">
      <app-specificForm></app-specificForm>
    </tab>
    <tab heading="{{ 'ContactTabs.DisasterRelief' | translate }}">
      <app-ads820></app-ads820>
    </tab>
    <tab heading="{{ 'ContactTabs.Business' | translate }}">
      <app-businessForm></app-businessForm>
    </tab>
    <tab heading="{{ 'ContactTabs.Prop19' | translate }}">
      <app-exclusionsForm></app-exclusionsForm>
    </tab>
    <tab heading="{{ 'ContactTabs.TaxSavings' | translate }}">
      <app-taxSavingsForm></app-taxSavingsForm>
    </tab>

  </tabset>
</div>

